:root {
  --settings-list-space-8: 8px;
  --settings-list-space-12: 12px;
  --settings-list-space-4: 4px;
  --settings-list-space-6: 6px;
  --settings-list-space-2: 2px;
}

.settings-list-page {
  /* Listen folgen ihrer Inhaltshöhe und füllen keine freie Viewport-Höhe auf. */
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
}
/* Kopf einer freistehenden Liste: der Kartenkörper ist randlos, der Kopf polstert sich wie die Werkzeugleiste.
   Doppelte Klasse, weil der später geladene Kit-Reset `.ck-flex { padding: 0 }` sonst gewinnt. */
.settings-list-card-header.settings-list-card-header--inset {
  padding: var(--mq-space-sm) var(--mq-space-md);
}
.settings-list-card-children {
  display: grid;
  gap: var(--settings-list-space-8);
  margin-top: var(--settings-list-space-8);
  padding-left: var(--settings-list-space-12);
  border-left: 3px solid color-mix(in srgb, var(--ant-color-primary) 22%, transparent);
}
.settings-list-card-child {
  background: color-mix(in srgb, var(--ant-color-primary) 4%, transparent);
}
.settings-list-card-field-value {
  max-width: 100%;
}
.settings-list-card-field-label {
  color: var(--ant-color-text-secondary);
  flex-shrink: 0;
}
@media (max-width: 575px) {
  .settings-list-card-field-row {
    align-items: flex-start !important;
  }
  .settings-list-card-field-label {
    flex: 0 1 140px;
    max-width: 42%;
    overflow-wrap: break-word;
    word-break: normal;
  }
  .settings-list-card-field-value {
    flex: 1 1 0;
    min-width: 0;
    text-align: left !important;
  }
}
@media (max-width: 575px) {
  .settings-list-card-field-label {
    max-width: 38%;
  }
}
@media (max-width: 359px) {
  .settings-list-card-field-label,
  .settings-list-card-field-value {
    flex-basis: 100%;
    max-width: 100%;
  }
}
.settings-list-card-actions-row {
  align-self: stretch;
  flex: 0 0 auto;
  row-gap: var(--settings-list-space-8);
  justify-content: flex-end !important;
  align-items: center;
  text-align: right;
}
.settings-list-card-actions-row > * {
  flex: 0 0 auto;
}
@media (max-width: 575px) {
  .settings-list-card-actions-row {
    flex-direction: column;
    align-items: flex-end !important;
  }
}
/* Titel/Untertitel nehmen den Restplatz und brechen selbst um; sonst schiebt ein langer Untertitel
   die Aktionen in eine eigene Zeile nach links. Bricht der Kopf doch um, bleiben sie rechts. */
.page-header-main {
  flex: 1 1 20rem;
}
.page-header-extra {
  flex: 0 0 auto;
  min-width: 0;
  margin-inline-start: auto;
  display: flex;
  justify-content: flex-end;
}
.settings-list-toolbar-extra,
.settings-list-toolbar-right {
  max-width: 100%;
}
.settings-list-toolbar-extra {
  display: flex;
  justify-content: flex-start;
}
.settings-list-toolbar-extra .ck-select,
.settings-list-toolbar-right .ck-select,
.settings-list-toolbar-extra .ck-picker,
.settings-list-toolbar-right .ck-picker {
  max-width: 100%;
}
@media (max-width: 767px) {
  .settings-list-toolbar-extra {
    width: 100%;
  }
  .settings-list-toolbar-extra > div {
    min-width: 0;
  }
  .settings-list-toolbar-extra .ck-select,
  .settings-list-toolbar-extra .ck-picker {
    width: 100% !important;
    min-width: 0 !important;
  }
  .settings-list-toolbar-extra > div {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }
  /* Gestapelt wird die Leiste zur Spalte: eine Breitenvorgabe der Produkte (`flex: 1 1 360px`) wirkte sonst als Höhe. */
  .settings-list-toolbar-extra > div > * {
    flex-basis: auto !important;
  }
  .settings-list-toolbar-right {
    justify-content: flex-end !important;
  }
  .page-header-main,
  .page-header-extra {
    width: 100%;
    flex: 1 1 100%;
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .settings-list-toolbar-row {
    flex-direction: row !important;
    align-items: flex-end !important;
    flex-wrap: wrap !important;
  }
  .settings-list-toolbar-extra {
    width: auto;
    flex: 0 1 auto;
  }
  .settings-list-toolbar-extra > div {
    width: auto;
    flex-direction: row;
    align-items: center;
  }
  .settings-list-toolbar-extra .ck-select,
  .settings-list-toolbar-extra .ck-picker {
    width: auto !important;
  }
  .settings-list-toolbar-right {
    width: auto !important;
  }
}
:root[data-theme="dark"] .settings-list-card-children {
  border-left-color: color-mix(in srgb, var(--ant-color-primary) 34%, transparent);
}
:root[data-theme="dark"] .settings-list-card-child {
  background: color-mix(in srgb, var(--ant-color-primary) 12%, transparent);
}

